import { CenterBudgets } from '../../lib/types/models/center/center-budget'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getCenterBudget(id: number) {
  return restApiClient
    .url(constructApiUrl(API.centers.getCenterBudget.url, { id }))
    .get<CenterBudgets>()
}
